export function parseForDisplay(vin) {
    return vin.replaceAll('-', '/');
}
